<app-theme-option [categories]="themeOptions.optionsConfiguration[optionType].categories" [label]="themeOptions.optionsConfiguration[optionType].label">
    <div app-theme-option-content>
      <app-check [color]="color" [value]="themeOptions.options().tooltips.intersect" (sendValue)="receiveValue($event)"></app-check>
    </div>
  </app-theme-option>